import { FrameTimerEventEmitter, FrameTimerEvents, CreateFrameTimer } from "../../../Utils/FrameTimer";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { Platforms } from "neo-games";

export class LimitDialog {
    private static _opened: boolean = false;
    private static _limit: HTMLElement;
    private static _openTimer: FrameTimerEventEmitter;
    private static _closeTimer: FrameTimerEventEmitter;

    static openDialog(): void {
        LimitDialog.initializeDialog();

        if (!LimitDialog._opened) {
            LimitDialog._openTimer.start(1);
            if (LimitDialog._limit != null) {
                LimitDialog._limit.style.display = "block";
            }

            LimitDialog._opened = true;
            Platforms.Platforms.dialogOpened("limit", true);
        }
    }

    static closeDialog(): void {
        if (LimitDialog._opened) {
            LimitDialog.initializeDialog();

            LimitDialog._closeTimer.start(60);
            if (LimitDialog._limit != null && !LimitDialog._limit.classList.contains("_disabled")) {
                LimitDialog._limit.classList.add("_disabled");
            }

            Platforms.Platforms.dialogOpened("limit", false);
        }
    }

    private static initializeDialog(): void {
        if (LimitDialog._limit == null) {
            LimitDialog._limit = document.getElementById("limitDialog");
        }

        if (LimitDialog._openTimer == null) {
            LimitDialog._openTimer = CreateFrameTimer("openTimer");
            LimitDialog._openTimer.on(FrameTimerEvents.Complete, this.showDialog);
        }

        if (LimitDialog._closeTimer == null) {
            LimitDialog._closeTimer = CreateFrameTimer("closeTimer");
            LimitDialog._closeTimer.on(FrameTimerEvents.Complete, this.hideDialog);
        }
    }

    private static showDialog(): void {
        LimitDialog.initializeDialog();

        if (LimitDialog._limit != null && LimitDialog._limit.classList.contains("_disabled")) {
            LimitDialog._limit.classList.remove("_disabled");
            PlayList.play("SND_BaseLimit");
        }
    }

    private static hideDialog(): void {
        LimitDialog.initializeDialog();
        if (LimitDialog._limit != null) {
            LimitDialog._limit.style.display = "none";
        }

        LimitDialog._opened = false;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Dialogs/LimitDialog.ts
 **/